import React, { useEffect, useState } from 'react';
import './Features.css';
import invoice from '../assets/WEB 2.png';
import dashboard from '../assets/WEB 4.png';
import clients from '../assets/WEB 1.png';
import analytics from '../assets/analytics.jpg';
import laptop from '../assets/WEB 3.png';
import expenses from '../assets/WEB 6.png';
import projects from '../assets/WEB 7.png';

function Features() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const translateYValue = scrollY * 0.01;

  return (
    <section id="features" className="features-section container">
      <h2 className="features-title fade-up">Complete Business Management Modules</h2>

      {/* 1) Client Management */}
      <div className="features-row fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(${translateYValue * 0.6}px)` }}
        >
          <img src={clients} alt="Client management and analytics" />
        </div>
        <div className="feature-content fade-up">
          <h3>Client Management</h3>
          <p>
            Centralize client data, link financials, and visualize performance with revenue analytics.
          </p>
          <ul>
            <li>Add/edit clients with name, email, company, GST, address using popups.</li>
            <li>Client selection dropdown with side panel during invoicing or income entry.</li>
            <li>Client-wise invoice tracking: numbers, dates, due, amounts, statuses, filters.</li>
            <li>Top Clients Revenue chart and invoice vs. paid insights with behavior trends.</li>
          </ul>
          <p className="feature-note">
            Future: Clients as single source of truth, deeper analytics integration, and two-way communication.
          </p>
        </div>
      </div>

      {/* 2) Project Management */}
      <div className="features-row reverse fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(-${translateYValue * 0.25}px)` }}
        >
          <img src={projects} alt="Project management board" />
        </div>
        <div className="feature-content fade-up">
          <h3>Project Management</h3>
          <p>
            Plan and deliver projects with phase-wise structure, team allocation, client visibility, and milestone billing.
          </p>
          <ul>
            <li></li>
            <li>Task and team allocation for accountability and optimal utilization.</li>
            <li>Project creation with phases/milestones and detailed deliverable descriptions.</li>
            <li>Phase-wise billing tied to milestones; portfolio and analytics on revenue and timelines.</li>
          </ul>
        </div>
      </div>

      {/* 3) Invoices and Quotes */}
      <div className="features-row fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(${translateYValue}px)` }}
        >
          <img src={invoice} alt="Invoices module preview" />
        </div>
        <div className="feature-content fade-up">
          <h3>Invoices & Quotes</h3>
          <p>
            Create branded, GST-ready quotes and invoices, manage lifecycle, and collect faster with reminders and analytics.
          </p>
          <ul>
            <li>Professional quote and invoice creation with taxes, discounts, terms, and PDF export.</li>
            <li>Quote management and one-click quote-to-invoice conversion pipeline.</li>
            <li>Status tracking (Sent/Accepted/Expired for quotes; Paid/Unpaid/Overdue for invoices).</li>
            <li>Automated payment reminders via email with links and clear instructions.</li>
          </ul>
          <p className="feature-note">
            Future: Multi-currency support and direct online payments with Razorpay/Stripe.
          </p>
        </div>
      </div>

      {/* 4) Recurring Invoices */}
      <div className="features-row reverse fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(-${translateYValue * 0.5}px)` }}
        >
          <img src={dashboard} alt="Recurring invoices interface" />
        </div>
        <div className="feature-content fade-up">
          <h3>Recurring Invoices</h3>
          <p>
            Automate subscription or repeat billing with scheduled generation and reminder workflows.
          </p>
          <ul>
            <li>Auto-generate invoices weekly, monthly, or custom intervals with end dates.</li>
            <li>Automated due-date reminders to keep collections on time.</li>
            <li>Parent–child hierarchy view for subscription billing history and tracking.</li>
          </ul>
        </div>
      </div>

      {/* 5) Employee Management (Pay slips & HR) */}
      <div className="features-row fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(${translateYValue * 0.4}px)` }}
        >
          <img src={laptop} alt="Employee management and payslips" />
        </div>
        <div className="feature-content fade-up">
          <h3>Employee Management (Pay Slips & HR)</h3>
          <p>
            Maintain employee records and generate compliant pay slips with structured earnings, deductions, and net pay.
          </p>
          <ul>
            <li>Employee profiles: role, join date, PAN, bank details, and identifiers.</li>
            <li>Pay slip generation with earnings/deductions tables and net pay in words.</li>
            <li>Two-column days/attendance block and summary totals for clarity.</li>
            <li>PDF-ready formatting, logo/brand, and computed totals with rounding.</li>
          </ul>
          <p className="feature-note">
            Future: Attendance, leave policies, payroll runs, and statutory filings integration.
          </p>
        </div>
      </div>

      {/* 6) Income & Expenses */}
      <div className="features-row reverse fade-up">
        <div
          className="feature-image fade-up"
          style={{ transform: `translateY(-${translateYValue * 0.3}px)` }}
        >
          <img src={expenses} alt="Income and expenses UI" />
        </div>
        <div className="feature-content fade-up">
          <h3>Income & Expenses</h3>
          <p>
            Record, categorize, and bulk-upload financial entries with modals, validation, and seamless data storage.
          </p>
          <ul>
            <li>Income entries with source, description, amount, date; real-time dashboard updates.</li>
            <li>Expense entries with category, amount, description, date; bulk CSV upload with validation.</li>
            <li>Pop-up modals with disabled states, smooth UX, and background scroll lock.</li>
          </ul>
          <p className="feature-note">
            Future: Recurring entries, AI receipt scanning, automated purchase/sales entries, COGS, and combined analytics.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Features;
